import { Link, type CreateLinkProps } from '@tanstack/react-router';
import { Pencil } from 'lucide-react';
import { Button } from '@/components/ui/button';

type SuperadminBarProps = Pick<CreateLinkProps, 'to' | 'params'>;

/**
 * Admin action bar shown to superadmins on event and organizer pages
 * they do not personally manage. Provides a direct edit link without
 * triggering any claiming or ownership side effects.
 */
export function SuperadminBar({ to, params }: SuperadminBarProps) {
  return (
    <div className="bg-slate-900 text-white">
      <div className="max-w-5xl mx-auto px-4 py-2.5 flex items-center justify-between">
        <span className="text-sm font-medium">You are a superadmin</span>
        <Button
          size="sm"
          variant="outline"
          className="border-slate-600 text-white hover:bg-slate-800 h-8 text-xs"
          asChild
        >
          <Link to={to} params={params}>
            <Pencil className="w-3.5 h-3.5 mr-1.5" />
            Superadmin Edit
          </Link>
        </Button>
      </div>
    </div>
  );
}
